import { type AttributeConfig } from "@src/context/attributeConfig/AttributeConfigContext";
import { Routes } from "@src/context/router/RouterContext";

export const getInitialRoute = (config: AttributeConfig): Routes => {
    if (config.entryPoint) {
        if (config.entryPoint.view.toString() === "model" && config.entryPoint.modelArticleNumber) {
            return Routes.ComponentGroupOverview;
        }
        if (config.showCompatibilityCheck && config.entryPoint.view.toString() === Routes.CompatibilityCheck.toString()) {
            return Routes.CompatibilityCheck;
        }
    }

    return Routes.Landing;
};
